import { MappedClass, MappedProperty, MappedPropertyCurrency } from '@h5s/util-object';
import Big from 'big.js';
import { Product } from './product';

export interface UpdateProductFields {
  id: number;
  available?: boolean;
  basePrice: Big;
  category2Id?: number | null;
  categoryId?: number | null;
  channelManagerCode?: string | null;
  costCenterId?: number | null;
  defaultPriceListId?: number | null;
  departmentId?: number | null;
  description: string;
  descriptionDe?: string | null;
  descriptionEn?: string | null;
  descriptionEs?: string | null;
  descriptionFr?: string | null;
  exportCode?: string | null;
  notes?: string | null;
  notesDe?: string | null;
  notesEn?: string | null;
  notesEs?: string | null;
  notesFr?: string | null;
  priceLists?: number[];
  vat?: Big | null;
  vatRateId?: number | null;
  webAvailable?: boolean;
}

@MappedClass()
export class UpdateProduct implements UpdateProductFields {
  @MappedProperty()
  id: number;

  @MappedProperty()
  available?: boolean;

  @MappedPropertyCurrency()
  basePrice: Big;

  @MappedProperty()
  category2Id?: number | null;

  @MappedProperty()
  categoryId?: number | null;

  @MappedProperty()
  channelManagerCode?: string | null;

  @MappedProperty()
  costCenterId?: number | null;

  @MappedProperty()
  defaultPriceListId?: number | null;

  @MappedProperty()
  departmentId?: number | null;

  @MappedProperty()
  description: string;

  @MappedProperty()
  descriptionDe?: string | null;

  @MappedProperty()
  descriptionEn?: string | null;

  @MappedProperty()
  descriptionEs?: string | null;

  @MappedProperty()
  descriptionFr?: string | null;

  @MappedProperty()
  exportCode?: string | null;

  @MappedProperty()
  notes?: string | null;

  @MappedProperty()
  notesDe?: string | null;

  @MappedProperty()
  notesEn?: string | null;

  @MappedProperty()
  notesEs?: string | null;

  @MappedProperty()
  notesFr?: string | null;

  @MappedProperty()
  priceLists?: number[];

  @MappedPropertyCurrency()
  vat?: Big | null;

  @MappedProperty()
  vatRateId?: number | null;

  @MappedProperty()
  webAvailable?: boolean;

  constructor(fields?: UpdateProductFields) {
    Object.assign(this, fields);
  }

  public static fromProduct(product: Product): UpdateProduct {
    return new UpdateProduct({
      id: product.id,
      available: product.available,
      basePrice: product.basePrice,
      category2Id: product.category2Id,
      categoryId: product.categoryId,
      channelManagerCode: product.channelManagerCode,
      costCenterId: product.costCenterId,
      defaultPriceListId: product.defaultPriceListId,
      departmentId: product.departmentId,
      description: product.description,
      descriptionDe: product.descriptionDe,
      descriptionEn: product.descriptionEn,
      descriptionEs: product.descriptionEs,
      descriptionFr: product.descriptionFr,
      exportCode: product.exportCode,
      notes: product.notes,
      notesDe: product.notesDe,
      notesEn: product.notesEn,
      notesEs: product.notesEs,
      notesFr: product.notesFr,
      priceLists: product.priceLists.map((priceList) => priceList.id),
      vat: product.vat,
      vatRateId: product.vatRateId,
      webAvailable: product.webAvailable,
    });
  }
}
